<template>
  <div :class="['text-h6 text-md-h5', colorClass, alignClass]">
    <span class="font-secondary">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (val) =>
        ["primary", "secondary", "accent", "black", "white"].includes(val),
    },
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
  },
  computed: {
    colorClass() {
      return `${this.color}--text`;
    },
    alignClass() {
      const classes = {
        left: "justify-start",
        center: "justify-center text-center",
        right: "justify-end text-right",
      };

      return classes[this.align];
    },
  },
};
</script>
